import styled from 'styled-components';
import { FileUploader } from 'react-drag-drop-files';
import { fileTypes } from 'components/Main/Gallery/ARContainer';
import { saveFiletoS3 } from '../Main/Brief/UploadFile/saveFiletoS3';
import React, { useContext, useEffect, useState, useRef } from 'react';
import APIContext from 'context/APIContext';
import { DarkButton } from 'components/style/Global';
import { GridLayout, GridLayoutInput } from 'API';
import { useSaveNewSectionItem } from './CustomReportsHooks/useCustomReportsGrid';
import { removeTypename } from 'methods/removeTypename';
import { useCustomReportContext } from 'context/CustomReportContext';
import DeleteConfirmationModal from 'components/DeleteConfirmationModall';
import { createPortal } from 'react-dom';

export const CustomReportFileStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  /* min-height: 80vh; */

  overflow: hidden;
  position: relative;
  gap: 0.1vw;
  padding: 0.4vw;
  .action-buttons-container {
    display: flex;
    justify-content: end;
    gap: 0.6vw;
    margin-top: 1vw;
  }

  &:hover {
    .edit-btns {
      display: flex !important;
      flex-direction: row;
      gap: 5px;
      background-color: transparent;
    }
  }

  .edit-btns {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;

    .edit-btn {
      font-weight: 300;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      cursor: pointer;
      padding: 8px;
      transition: all 0.2s;
      background-color: ${({ theme }) => theme.c50};
      color: ${({ theme }) => theme.brand};
      border: 1px solid ${({ theme }) => theme.c200};
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;

      &:hover {
        /* outline: 1px solid ${({ theme }) => theme.c200}; */
        transform: scale(1.1);
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    overflow: hidden;
  }
  .drop_area {
    width: 80%;
    height: 20vh;
    display: flex;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    border: 2px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    color: #999;
    font-family: 'fontRegular';
    text-align: center;
    padding: 20px;
    margin: auto;
    transition: background-color 0.3s ease;
    &:hover {
      background-color: #e6f7ff;
    }

    h1 {
      font-size: 20px;
      font-weight: bold;
      margin: 0;
      color: ${({ theme }) => theme.primaryGray};
    }
    h2 {
      font-size: 12px;
      font-weight: normal;
      margin: 5px 0;
      color: ${({ theme }) => theme.secondaryGray};
    }

    .dragDropMessage {
      font-size: 14px;
      font-weight: normal;
      margin: 15px 0 0 0;
      color: ${({ theme }) => theme.secondaryGray};
    }
  }
  .fileContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    gap: 0.1vw;
    padding: 0.4vw;
    border: 2px dashed #d9d9d9;
    border-radius: 4px;

    h1 {
      font-size: 12px;
      font-weight: bold;
      margin: 0;
      color: ${({ theme }) => theme.primaryGray};
      display: flex; /* Use flexbox for alignment */
      align-items: center; /* Vertically align icon and text */
      .icon {
        font-size: 16px; /* Adjust icon size */
      }
    }
    .imageContainer {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
      cursor: pointer;
      position: relative;

      width: 100%;

      img {
        width: 30%;
        height: 100%;
        object-fit: contain;
      }

      video {
        width: 30%;
        height: 100%;
        object-fit: contain;
      }

      iframe {
        width: 80%;
        height: 100%;
        border: none;
      }

      .document-preview {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px;
        border-radius: 8px;
        background-color: ${({ theme }) => theme.placeholderBackground};
        width: 80%;
        height: 80%;

        .document-icon {
          margin-bottom: 10px;
          .icon {
            font-size: 48px;
            color: ${({ theme }) => theme.brand};
          }
        }

        .document-info {
          text-align: center;
          margin-bottom: 15px;

          p {
            margin: 5px 0;
            font-size: 12px;
            color: ${({ theme }) => theme.primaryGray};

            &:first-child {
              font-weight: bold;
              word-break: break-word;
            }
          }
        }

        .document-download-btn {
          padding: 8px 16px;
          background-color: ${({ theme }) => theme.brand};
          color: white;
          text-decoration: none;
          border-radius: 4px;
          font-size: 12px;
          transition: background-color 0.2s;

          &:hover {
            background-color: ${({ theme }) => theme.brand};
            opacity: 0.9;
          }
        }
      }

      h1 {
        font-size: 12px;
        font-weight: bold;
        margin: 10px 0 0 0;
        color: ${({ theme }) => theme.primaryGray};
      }
    }
  }

  .mainPreview {
    /* width: 100%;
    height: 100%; */
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    border-radius: 6px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      position: relative;
      z-index: 1;
      border-radius: 6px;
    }

    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
      pointer-events: auto; /* Allow video controls to work */
      position: relative;
      z-index: 1;
      border-radius: 6px;
    }

    iframe {
      width: 100%;
      height: 100%;
      border: none;
      pointer-events: auto;
      position: relative;
      z-index: 1;
      border-radius: 6px;
    }

    /* Make sure edit buttons show above all content */
    & + .edit-btns,
    .edit-btns {
      z-index: 20 !important;
    }

    .document-preview {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 10px;
      width: 100%;
      height: 100%;
      background-color: ${({ theme }) => theme.placeholderBackground};
      border-radius: 4px;
      position: relative;
      z-index: 1;

      .document-icon {
        margin-bottom: 8px;
        .icon {
          font-size: 32px;
          color: ${({ theme }) => theme.brand};
        }
      }

      .document-info {
        text-align: center;

        p {
          margin: 2px 0;
          font-size: 10px;
          color: ${({ theme }) => theme.primaryGray};
          word-break: break-word;

          &:first-child {
            font-weight: bold;
          }
        }
      }
    }
  }
  h2 {
    margin-top: 10px;
    display: flex; /* Use flexbox for alignment */
    align-items: center; /* Vertically align icon and text */
    font-size: 12px;
    font-family: 'FontRegular';
    color: ${({ theme }) => theme.primaryGray};
    font-weight: 100;

    .icon {
      font-size: 16px; /* Adjust icon size */
      color: ${({ theme }) => theme.primaryGray};
      margin-right: 5px; /* Add spacing between icon and text */
      display: inline-flex; /* Ensure proper alignment */
      align-items: center; /* Vertically align icon */
    }
  }
`;

type Props = {
  layoutItem: GridLayout;
  modal?: boolean;
  handleModalType?: (item: GridLayout | null, type: string | null) => void;
  deleteItem?: (sectionID: string, sectionItemID: string) => void;
  sectionID: string | null | undefined;
  fetchFile: (sectionItemID: string) => Promise<File | null>;
  selectedFile: File | null;
  onFileSaved?: (sectionItemID: string, file: File) => void;
};

const CustomReportFile = (props: Props) => {
  const {
    layoutItem,
    modal,
    handleModalType,
    deleteItem,
    sectionID,
    fetchFile,
    selectedFile: propSelectedFile,
    onFileSaved,
  } = props;

  // Track renders only for debugging - comment out in production

  const { getEnvironment } = useContext(APIContext);
  const [saveNewSectionItem] = useSaveNewSectionItem();
  const { activeCustomReport, safeSectionLayoutUpdate, setPublishPlaceholderObject } = useCustomReportContext();
  const userIsAuthorized = activeCustomReport?.authorized;

  const [localSelectedFile, setLocalSelectedFile] = useState<File | null>(propSelectedFile);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // const [showViewModal, setShowViewModal] = useState(false);
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const fetchCalled = useRef(false);

  useEffect(() => {
    // Reset fetch flag when section item changes
    fetchCalled.current = false;
  }, [layoutItem.SectionItemID]);

  useEffect(() => {
    if (!propSelectedFile && layoutItem.SectionItemID && fetchFile && !fetchCalled.current) {
      fetchCalled.current = true;
      // Debounce fetchFile calls to avoid excessive API calls
      const timeoutId = setTimeout(() => {
        if (layoutItem.SectionItemID) {
          fetchFile(layoutItem.SectionItemID);
        }
      }, 50);

      return () => clearTimeout(timeoutId);
    }
  }, [layoutItem.SectionItemID, propSelectedFile, fetchFile]);

  const fileToShow = modal ? localSelectedFile : propSelectedFile;

  // Use useRef to track if placeholder was already set for this file
  const lastPlaceholderFile = useRef<string | null>(null);

  useEffect(() => {
    if (fileToShow && layoutItem.SectionItemID) {
      const currentFileName = fileToShow.name;

      // Only update if this is a different file than last time
      if (lastPlaceholderFile.current !== currentFileName) {
        lastPlaceholderFile.current = currentFileName;

        const placeholdersObject = {
          position: String(layoutItem.SectionItemID),
          outputlocation: fileToShow?.name || ('' as string),
          outputlocationTotal: 'noTotal',
          metrics: {
            chartType: fileToShow?.type as string,
            metric: 'image',
            axis: 1,
          },
        };
        const IdtoUse = layoutItem.SectionItemID;

        // Use timeout to batch placeholder updates and avoid excessive calls
        const timeoutId = setTimeout(() => {
          setPublishPlaceholderObject((prev) => ({
            ...prev,
            [IdtoUse || '']: placeholdersObject,
          }));
        }, 100);

        return () => clearTimeout(timeoutId);
      }
    }
  }, [fileToShow, layoutItem.SectionItemID, setPublishPlaceholderObject]);

  // Helper function to clean filename by removing UUID prefix
  const cleanFileName = (fileName: string) => {
    if (!fileName) return '';
    // Split by underscore and take everything after the first underscore
    const underscoreIndex = fileName.indexOf('_');
    if (underscoreIndex > 0) {
      return fileName.substring(underscoreIndex + 1);
    }
    return fileName;
  };

  // Create and manage fileUrl in useEffect - always create URL for files
  useEffect(() => {
    if (fileToShow) {
      // Always create new URL for file to avoid broken links
      const url = URL.createObjectURL(fileToShow);
      setFileUrl(url);

      // Cleanup function
      return () => {
        URL.revokeObjectURL(url);
      };
    } else {
      setFileUrl(null);
    }
  }, [fileToShow]);

  // Function to render file preview based on file type
  const renderFilePreview = (file: File, isModal: boolean = false) => {
    if (!file || !fileUrl) return null;

    const fileName = file.name.toLowerCase();
    const cleanedFileName = cleanFileName(file.name);

    // Video files
    if (file.type.includes('video')) {
      return (
        <video
          controls
          width={isModal ? '600' : undefined}
          src={fileUrl}
          style={{
            cursor: isModal ? 'pointer' : 'default',
            pointerEvents: 'auto',
            zIndex: 1,
          }}
        />
      );
    }

    // Image files
    if (file.type.includes('image')) {
      return (
        <img
          src={fileUrl}
          alt="File preview"
          style={{
            cursor: isModal ? 'pointer' : 'default',
            width: isModal ? '600px' : undefined,
            height: isModal ? 'auto' : undefined,
            maxHeight: isModal ? '500px' : undefined,
            objectFit: 'contain',
          }}
        />
      );
    }

    // PDF files
    if (fileName.endsWith('.pdf')) {
      return (
        <iframe
          src={fileUrl}
          title="PDF preview"
          width={isModal ? '70vw' : undefined}
          height={isModal ? '60vh' : undefined}
          style={{
            pointerEvents: 'auto',
            zIndex: 1,
          }}
        />
      );
    }

    // Office and other document files
    const getDocumentIcon = (fileName: string) => {
      if (fileName.endsWith('.docx') || fileName.endsWith('.doc')) return 'description';
      if (fileName.endsWith('.pptx') || fileName.endsWith('.ppt')) return 'slideshow';
      if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) return 'table_chart';
      return 'insert_drive_file';
    };

    return (
      <div className="document-preview">
        <div className="document-icon">
          <span className="icon material-symbols-outlined">{getDocumentIcon(fileName)}</span>
        </div>
        <div className="document-info">
          <p>{cleanedFileName}</p>
          <p>{(file.size / 1024 / 1024).toFixed(2)} MB</p>
        </div>
        {isModal && (
          <a href={fileUrl} download={cleanedFileName} className="document-download-btn">
            Download
          </a>
        )}
      </div>
    );
  };

  const handleSave = async () => {
    const updateAndClose = (id: string) => {
      // Get fresh sectionLayoutState when function is called, not as dependency
      safeSectionLayoutUpdate((currentState) => {
        return currentState.map((section) => {
          return {
            ...section,
            SectionElements: section.SectionElements?.map((el) => {
              if (el?.SectionItemID === id || el?.GridPosition?.i === layoutItem.GridPosition?.i) {
                return {
                  ...el,
                  Position: layoutItem.Position,
                  SectionItemID: id,
                  Open: false,
                  __typename: 'GridLayout',
                } as GridLayout;
              }
              return el;
            }),
          };
        });
      });

      if (onFileSaved && fileToShow) {
        onFileSaved(layoutItem.SectionItemID as string, fileToShow);
      }
    };
    if (!fileToShow) {
      alert('No file selected');
      return;
    }
    const cleanedLayoutItem = removeTypename(layoutItem);
    if (!layoutItem.SectionItemID) {
      delete cleanedLayoutItem.SectionItemID;
      delete cleanedLayoutItem.Open;
      await saveNewSectionItem(sectionID as string, cleanedLayoutItem as GridLayoutInput).then((res) => {
        if (res.status === 200) {
          const saveToS3 = saveFiletoS3(
            fileToShow,
            res.id as string,
            activeCustomReport?.CustomReportID as number,
            activeCustomReport?.Client?.Code as string,
            activeCustomReport?.Client?.Country as string,
            getEnvironment,
            'CustomReports',
          );
          if (saveToS3) {
            if (onFileSaved && fileToShow) {
              onFileSaved(res.id as string, fileToShow);
            }
            updateAndClose(res.id as string);
          }
        } else {
          alert(res.message);
        }
      });
    } else {
      try {
        const saveToS3 = await saveFiletoS3(
          fileToShow,
          layoutItem.SectionItemID as string,
          activeCustomReport?.CustomReportID as number,
          activeCustomReport?.Client?.Code as string,
          activeCustomReport?.Client?.Country as string,
          getEnvironment,
          'CustomReports',
        );

        if (saveToS3) {
          updateAndClose(layoutItem.SectionItemID as string);
        }
      } catch (err) {
        console.error('Error saving file:', err);
        alert('Failed to save file. Please try again.');
      }
    }
  };

  return (
    <CustomReportFileStyled style={{ minHeight: modal ? '80vh' : 'auto' }}>
      {!modal && userIsAuthorized && (
        <div className="edit-btns">
          <div
            onClick={() => handleModalType && handleModalType(layoutItem, 'file')}
            className="edit-btn icon material-symbols-outlined"
          >
            edit
          </div>
          <div className="edit-btn icon material-symbols-outlined" onClick={() => setShowDeleteModal(true)}>
            delete
          </div>
        </div>
      )}
      {!modal && !userIsAuthorized && propSelectedFile && (
        <div className="edit-btns">
          <div
            onClick={() => handleModalType && handleModalType(layoutItem, 'file')}
            className="edit-btn icon material-symbols-outlined"
          >
            visibility
          </div>
        </div>
      )}
      {modal ? (
        <>
          {fileToShow ? (
            <div className="fileContainer">
              <div
                className="imageContainer"
                onClick={() => {
                  // Only trigger download for non-media files
                  if (
                    !fileToShow.type.includes('video') &&
                    !fileToShow.type.includes('image') &&
                    !fileToShow.name.toLowerCase().endsWith('.pdf')
                  ) {
                    const url = URL.createObjectURL(fileToShow);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = cleanFileName(fileToShow.name);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                  }
                }}
              >
                {renderFilePreview(fileToShow, true)}
                <h1>
                  {cleanFileName(fileToShow.name)}
                  {!fileToShow.type.includes('video') &&
                    !fileToShow.type.includes('image') &&
                    !fileToShow.name.toLowerCase().endsWith('.pdf') && (
                      <span className="icon material-symbols-outlined">file_download</span>
                    )}
                </h1>
              </div>
              {userIsAuthorized && (
                <h2>
                  <span
                    onClick={() => {
                      setLocalSelectedFile(null);
                    }}
                    className="icon material-symbols-outlined"
                  >
                    delete
                  </span>
                  Clear Upload
                </h2>
              )}
            </div>
          ) : (
            <FileUploader
              name="file"
              className="drop_area"
              types={fileTypes}
              handleChange={(file: File) => setLocalSelectedFile(file)}
              children={
                <div className="drop_area">
                  <h1>Click to upload a file</h1>
                  <h2>Most video, image or MS office file formats are supported</h2>
                  <h2 className="or">OR</h2>
                  <h2 className="dragDropMessage">Drag and drop a file here</h2>
                </div>
              }
            />
          )}
          {userIsAuthorized && (
            <div className="action-buttons-container">
              <button onClick={() => handleModalType && handleModalType(null, null)} className="action-button">
                Cancel
              </button>
              <DarkButton onClick={handleSave} className="action-button">
                Save
              </DarkButton>
            </div>
          )}
        </>
      ) : (
        <div className="mainPreview">{fileToShow ? renderFilePreview(fileToShow, false) : <div>Loading...</div>}</div>
      )}

      {showDeleteModal &&
        createPortal(
          <DeleteConfirmationModal
            handleDeleteConfirmationModal={(confirmed) => {
              if (confirmed) {
                deleteItem && deleteItem(sectionID as string, layoutItem.SectionItemID as string);
              }
              setShowDeleteModal(false);
            }}
            modalObject={{
              title: 'Delete File Element',
              message: 'Are you sure you want to delete this file element? This action cannot be undone.',
              mainButton: 'Delete',
              secondaryButton: 'Cancel',
            }}
          />,
          document.body,
        )}

      {/* {showViewModal &&
        propSelectedFile &&
        createPortal(
          <div
            onClick={() => setShowViewModal(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                width: '90vw',
                maxWidth: '1200px',
                maxHeight: '90vh',
                position: 'relative',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px',
                overflow: 'auto',
              }}
            >
              <button
                onClick={() => setShowViewModal(false)}
                style={{
                  position: 'absolute',
                  top: '15px',
                  right: '20px',
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  zIndex: 1001,
                  color: '#666',
                  fontWeight: 'bold',
                }}
              >
                ×
              </button>

              <h3
                style={{
                  margin: '10px 0 0 0',
                  fontSize: '18px',
                  color: '#333',
                  textAlign: 'center',
                  paddingRight: '40px', // Make space for close button
                }}
              >
                {cleanFileName(propSelectedFile.name)}
              </h3>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  minHeight: '400px',
                }}
              >
                {(() => {
                  const fileName = propSelectedFile.name.toLowerCase();
                  // Render larger versions for view modal
                  if (propSelectedFile.type.includes('video')) {
                    return (
                      <video controls width="900" src={fileUrl || ''} style={{ maxWidth: '100%', height: 'auto' }} />
                    );
                  }
                  if (propSelectedFile.type.includes('image')) {
                    return (
                      <img
                        src={fileUrl || ''}
                        alt="File preview"
                        style={{
                          width: '900px',
                          height: 'auto',
                          maxWidth: '100%',
                          maxHeight: '70vh',
                          objectFit: 'contain',
                        }}
                      />
                    );
                  }
                  if (fileName.endsWith('.pdf')) {
                    return (
                      <iframe
                        src={fileUrl || ''}
                        title="PDF preview"
                        style={{
                          width: '80vw',
                          height: '70vh',
                          border: 'none',
                          maxWidth: '100%',
                        }}
                      />
                    );
                  }
                  // Office and other documents
                  return renderFilePreview(propSelectedFile, true);
                })()}
              </div>
            </div>
          </div>,
          document.body,
        )} */}
    </CustomReportFileStyled>
  );
};

export default CustomReportFile;
